import React, { FC, useEffect, useState } from 'react';
import { UiLibrary, ContentCardProps } from 'learning-panel-components';
import CardsGallery from './cardsGallery';
import CustomGrid from './customGrid';

interface CardsGalleryContainerProps {
    columns: number;
    rows: number;
    data: ContentCardProps[];
    title: string;
    infoTitle?: string;
    infoDescription?: string;
    noFullWidthColumn: number;
    fullWidth?: boolean;
}

const CardsGalleryContainer: FC<CardsGalleryContainerProps> = ({
    columns,
    rows,
    data,
    title,
    infoDescription,
    infoTitle,
    fullWidth,
    noFullWidthColumn
}) => {
    const [hover, setHover] = useState<boolean>(false);
    const [customGrids, setCustomGrids] = useState<React.ReactNode[]>([]);
    const [numOfPages, setNumOfPages] = useState<number>(0);

    const numInPage = fullWidth ? columns * rows : noFullWidthColumn * rows;

    const calcXsGrid = (columns: number): UiLibrary.GridSize => Math.floor(12 / columns) as UiLibrary.GridSize;
    const xsGrid = calcXsGrid(fullWidth ? columns : noFullWidthColumn);

    useEffect(() => {
        if (!data) return;
        setNumOfPages(Math.ceil(data.length / numInPage));

        const customGrids: React.ReactNode[] = Array.from({ length: Math.ceil(data.length / numInPage) }, (_, i) => {
            const start = i * numInPage;
            const end = start + numInPage;
            const sliceData = data.slice(start, end);

            return <CustomGrid data={sliceData} xsGrid={xsGrid} key={i} />;
        });

        setCustomGrids(customGrids);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, rows, columns, noFullWidthColumn, fullWidth]);

    return (
        <CardsGallery
            columns={fullWidth ? columns : noFullWidthColumn}
            hover={hover}
            setHover={setHover}
            customGrids={customGrids}
            numOfPages={numOfPages}
            title={title}
            total={data?.length || 0}
            infoDescription={infoDescription}
            infoTitle={infoTitle}
        />
    );
};

export default CardsGalleryContainer;
